import { render, staticRenderFns } from "./TotalSessionFeesPerDay.vue?vue&type=template&id=2ac74c85&"
import script from "./TotalSessionFeesPerDay.vue?vue&type=script&lang=ts&"
export * from "./TotalSessionFeesPerDay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports